import { createFileRoute, redirect } from '@tanstack/react-router';

// Legacy deep links (e.g. /details/$id/contacts/add) — forward the full path to the
// new list-nested location by rewriting the changed segment in place.
export const Route = createFileRoute('/console/$orgId/configuration/vendor-management/suppliers/details/$id/$')({
    beforeLoad: ({ location }) => {
        throw redirect({
            href: location.href.replace('/suppliers/details/', '/suppliers/list/details/'),
            replace: true,
        });
    },
});
